// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"0100bdfd","667":"e812e46b","977":"f7f80d1d"}[chunkId] + ".chunk.js";
};